import { render } from "./leftside.vue?vue&type=template&id=18814bcc&scoped=true"
import script from "./leftside.vue?vue&type=script&lang=js"
export * from "./leftside.vue?vue&type=script&lang=js"

import "./leftside.vue?vue&type=style&index=0&id=18814bcc&scoped=true&lang=scss"
import "./leftside.vue?vue&type=style&index=1&id=18814bcc&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18814bcc"]])

export default __exports__